'use client';
import { ZeusProvider } from '@zeus/core';
import { bookingIcons } from '@zeus/icons';
import mediaQuery from 'css-mediaquery';
import { PropsWithChildren, useMemo } from 'react';
import theme from '../theme/theme';

interface ThemeProviderProps extends PropsWithChildren {
  isMobile?: boolean;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  isMobile,
  children,
}) => {
  // SSR doesn't support `useMediaQuery` as the server can't access the browser size.
  // https://mui.com/material-ui/react-use-media-query/#server-side-rendering
  const themeWithSsrMediaQuery = useMemo(() => {
    const ssrMatchMedia = (query: string) => ({
      matches: mediaQuery.match(query, {
        width: isMobile ? '0px' : `${theme.breakpoints.values.lg}px`,
      }),
    });

    return {
      ...theme,
      components: {
        ...theme.components,
        MuiUseMediaQuery: { defaultProps: { ssrMatchMedia } },
      },
    };
  }, [isMobile]);

  return (
    <ZeusProvider theme={themeWithSsrMediaQuery} icons={bookingIcons}>
      {children}
    </ZeusProvider>
  );
};
